import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { RoadsideDesktopRoutes } from "../../../modules/roadside/routers/RoadsideRoutes"
import { RoadwayDesktopRoutes } from "../../../modules/roadway/routers/RoadwayRoutes"
import { RoadworksDesktopRoutes } from "../../../modules/roadworks/routers/RoadworksRoutes"
import { MODULE_ROADSIDE, MODULE_ROADWAY, MODULE_ROADWORKS } from "../../constants/modules"

export const RoadContentRouter = () => {

    const roadRoutes = useMemo(() => ([
        {
            path: `/${MODULE_ROADWAY}/*`,
            element: <RoadwayDesktopRoutes />,
        },
        {
            path: `/${MODULE_ROADWORKS}/*`,
            element: <RoadworksDesktopRoutes />,
        },
        {
            path: `/${MODULE_ROADSIDE}/*`,
            element: <RoadsideDesktopRoutes />,
        },
    ]), [])

    return useRoutes(roadRoutes)
}